import AuthenticatedLayout from "@/pages/Layouts/AuthenticatedLayout.vue";
import UnAuthenticatedLayout from "@/pages/Layouts/UnAuthenticatedLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// // Dashboard pages
// import DashboardSample from '@/pages/Dashboard/Dashboard.sample.vue';
//
// // Pages
// import User from "@/pages/Dashboard/Pages/UserProfile.vue";
// import Pricing from "@/pages/Dashboard/Pages/Pricing.vue";
// import TimeLine from "@/pages/Dashboard/Pages/TimeLinePage.vue";
// import RtlSupport from "@/pages/Dashboard/Pages/RtlSupport.vue";
// import Register from "@/pages/Dashboard/Pages/Register.vue";
// import Lock from "@/pages/Dashboard/Pages/Lock.vue";
//
// // Components pages
// import Buttons from "@/pages/Dashboard/Components/Buttons.vue";
// import GridSystem from "@/pages/Dashboard/Components/GridSystem.vue";
// import Panels from "@/pages/Dashboard/Components/Panels.vue";
// import SweetAlert from "@/pages/Dashboard/Components/SweetAlert.vue";
// import Notifications from "@/pages/Dashboard/Components/Notifications.vue";
// import Icons from "@/pages/Dashboard/Components/Icons.vue";
// import Typography from "@/pages/Dashboard/Components/Typography.vue";
//
// // Forms pages
// import RegularForms from "@/pages/Dashboard/Forms/RegularForms.vue";
// import ExtendedForms from "@/pages/Dashboard/Forms/ExtendedForms.vue";
import ValidationForms from "@/pages/Dashboard/Forms/ValidationForms.vue";
//
// // TableList pages
// import RegularTables from "@/pages/Dashboard/Tables/RegularTables.vue";
// import ExtendedTables from "@/pages/Dashboard/Tables/ExtendedTables.vue";
// import PaginatedTables from "@/pages/Dashboard/Tables/PaginatedTables.vue";
//
// // Maps pages
// import GoogleMaps from "@/pages/Dashboard/Maps/GoogleMaps.vue";
// import FullScreenMap from "@/pages/Dashboard/Maps/FullScreenMap.vue";
// import VectorMaps from "@/pages/Dashboard/Maps/VectorMaps.vue";
//
// // Calendar
// import Calendar from "@/pages/Dashboard/Calendar.vue";
// // Charts
// import Charts from "@/pages/Dashboard/Charts.vue";
// import Widgets from "@/pages/Dashboard/Widgets.vue";

// ZINK pages
import Summary from "@/pages/Summary.vue";
// import Capture1 from "@/pages/Capture1.vue";
import Capture from "@/pages/Capture.vue";
import Assessment from "@/pages/Assessment.vue";
import Dashboard from "@/pages/Dashboard.vue";
import Login from "@/pages/Login.vue";
import ForgotPassword from "@/pages/ForgotPassword.vue";
import ResetPassword from "@/pages/ResetPassword.vue";
import Logout from "@/pages/Logout.vue";
import BrokerSettlementForm from "@/pages/Settlement/BrokerSettlementForm.vue";
import SaveDealIncome from "@/pages/SaveDealIncome";
import Compliance from "@/pages/Compliance";
import Calculators from "@/pages/Calculators";
import PayslipCalculator from "@/pages/PayslipCalculator.vue";
import Auction from "@/pages/Auction";
import Communications from "@/pages/Communications.vue";
// import Calculators from "@/pages/Calculators";
import Tools from "@/pages/Tools";
import Services from "@/pages/Services";


// Auth middleware
import auth from "@/middleware/authentication.js";

import Templates from "@/pages/Templates.vue";
import Documents from "@/pages/Documents.vue";

// let componentsMenu = {
//     path: "/components",
//     component: AuthenticatedLayout,
//     redirect: "/components/buttons",
//     name: "Components",
//     children: [
//         {
//             path: "dashboard-sample",
//             name: "DashboardSample",
//             components: {default: DashboardSample}
//         },
//         {
//             path: "buttons",
//             name: "Buttons",
//             components: {default: Buttons}
//         },
//         {
//             path: "grid-system",
//             name: "Grid System",
//             components: {default: GridSystem}
//         },
//         {
//             path: "panels",
//             name: "Panels",
//             components: {default: Panels}
//         },
//         {
//             path: "sweet-alert",
//             name: "Sweet Alert",
//             components: {default: SweetAlert}
//         },
//         {
//             path: "notifications",
//             name: "Notifications",
//             components: {default: Notifications}
//         },
//         {
//             path: "icons",
//             name: "Icons",
//             components: {default: Icons}
//         },
//         {
//             path: "typography",
//             name: "Typography",
//             components: {default: Typography}
//         }
//     ]
// };
let formsMenu = {
    path: "/forms",
    component: AuthenticatedLayout,
    redirect: "/forms/regular",
    name: "Forms",
    children: [
        // {
        //     path: "regular",
        //     name: "Regular Forms",
        //     components: {default: RegularForms}
        // },
        // {
        //     path: "extended",
        //     name: "Extended Forms",
        //     components: {default: ExtendedForms}
        // },
        {
            path: "validation",
            name: "Validation Forms",
            components: {default: ValidationForms}
        },
    ]
};
//
// let tablesMenu = {
//     path: "/table-list",
//     component: AuthenticatedLayout,
//     redirect: "/table-list/regular",
//     name: "Tables",
//     children: [
//         {
//             path: "regular",
//             name: "Regular Tables",
//             components: {default: RegularTables}
//         },
//         {
//             path: "extended",
//             name: "Extended Tables",
//             components: {default: ExtendedTables}
//         },
//         {
//             path: "paginated",
//             name: "Pagianted Tables",
//             components: {default: PaginatedTables}
//         }
//     ]
// };
//
// let mapsMenu = {
//     path: "/maps",
//     component: AuthenticatedLayout,
//     name: "Maps",
//     redirect: "/maps/google",
//     children: [
//         {
//             path: "google",
//             name: "Google Maps",
//             components: {default: GoogleMaps}
//         },
//         {
//             path: "full-screen",
//             name: "Full Screen Map",
//             meta: {
//                 hideContent: true,
//                 hideFooter: true,
//                 navbarAbsolute: true
//             },
//             components: {default: FullScreenMap}
//         },
//         {
//             path: "vector-map",
//             name: "Vector Map",
//             components: {default: VectorMaps}
//         }
//     ]
// };
//
// let pagesMenu = {
//     path: "/pages",
//     component: AuthenticatedLayout,
//     name: "Pages",
//     redirect: "/pages/user",
//     children: [
//         {
//             path: "user",
//             name: "User Page",
//             components: {default: User}
//         },
//         {
//             path: "timeline",
//             name: "Timeline Page",
//             components: {default: TimeLine}
//         },
//         {
//             path: "rtl",
//             name: "وحة القيادة",
//             meta: {
//                 rtlActive: true
//             },
//             components: {default: RtlSupport}
//         }
//     ]
// };

let authPages = {
    path: "/",
    component: AuthLayout,
    name: "Authentication",
    beforeEnter: (to, from, next) => {
        // @.
        if ($cookies.get("token") != null) {
            next("/")
        }
        next()
    },
    children: [
        {
            path: "/login",
            name: "Login",
            component: Login

        },
        // {
        //     path: "/register",
        //     name: "Register",
        //     component: Register
        // },
        // {
        //     path: "/pricing",
        //     name: "Pricing",
        //     component: Pricing
        // },
        // {
        //     path: "/lock",
        //     name: "Lock",
        //     component: Lock
        // },
        {
            path: "/logout",
            name: "Logout",
            component: Logout
        }
    ]
};

const reportingTabTypes = [
    'broker_pods',
    'lenders',
    'loan_asset_type',
    'model_years',
    'user_pods',
    'roles',
];

const basketTypes = [
    'loan_asset_type',
    'model_years',
];

const captureTypes = [
    'address_history_ownership_options',
    'address_history_ownership_properties',
    'address_street_type',
    'assets_sale_types',
    'asset_finance_provider',
    'asset_type_options',
    'asset_type_properties',
    'capacity_rules',
    'countries',
    'country_states',
    'employment_industry',
    'employment_occupation',
    'employment_type_options',
    'expense_type',
    'gender',
    'identification_type',
    'income_type',
    'introducer_details',
    'license_type',
    'loan_application_type_options',
    'loan_application_type_properties',
    'marketing_source_type',
    'model_years',
    'payment_frequency_options',
    'personal_details_residency_status',
    'personal_details_marital_status_options',
    'personal_details_marital_status_properties',
    'privacy_consent_type_options',
    'reference_relationship',
];

const summaryTypes = [
    'assets_sale_types',
    'address_history_ownership_properties',
    'capacity_rules',
    'personal_details_marital_status_properties',
];

const assessmentTypes = [
    'address_history_ownership_properties',
    'assets_sale_types',
    'capacity_rules',
    'countries',
    'insurance_provider',
    'introducer_details',
    'lender_finance_one_name',
    'loan_application_type_properties',
    'model_years',
    'payment_frequency_options',
    'personal_details_marital_status_properties',
    'products_options',
    'products_properties',
    'submission_repayment_type',
    'submission_status_options',
];

const documentsTypes = [
    'document_templates',
    'document_types',
];

const communicationsTypes = [];

const settlementFormTypes = [
    'assets_sale_types',
    'countries',
    'insurance_provider',
    'introducer_details',
    'loan_application_type_properties',
    'model_years',
    'payment_frequency_options',
    'submission_repayment_type',
    'submission_status_options',
];

const dealIncomeTypes = [
    'insurance_provider',
    'settlement_expense_types',
];

const complianceTypes = [];

const auctionTypes = [];

const toolsTypes = [];

const servicesTypes = [];

const settlementTypes = [];

let applicationPages = {
    path: "/application/:id/",
    component: AuthenticatedLayout,
    name: "Application",
    props: {
        menu: [
            {path: 'dashboard', name: 'Reporting Dashboard', icon: 'dashboard', disabled: false, visible: true},
            /* {path: 'reporting', name: 'Reporting', icon: 'dashboard', disabled: false, visible: false}, */
            {path: 'basket', name: 'Work Basket', icon: 'shopping_basket', disabled: false, visible: true},
            {path: 'capture', name: 'Application', icon: 'assignment', disabled: true, visible: true},
            {path: 'summary', name: 'Summary', icon: 'fact_check', disabled: true, visible: true},
            {path: 'assessment', name: 'Assess & Submit', icon: 'rule', disabled: true, visible: true},
            //todo: create a permission for settlements
            {path: 'settlement_form', name: 'Settlement', icon: 'speaker_notes', disabled:true, visible: true},
            {path: 'deal_income', name: 'Deal Incomes', icon: 'local_offer', disabled:true, visible: true},
            {path: 'compliance', name: 'Compliance', icon: 'check_circle', disabled:true, visible: true},
            {path: 'documents', name: 'Documents', icon: 'attach_file', visible: true},
            {path: 'communications', name: 'Communication', icon: 'phone_forwarded', disabled: true, visible: true},
            {path: '/administration', name: 'Administration', icon: 'engineering', visible: false},
            // {path: 'calculators', name: 'Calculator', icon: 'analytics', disabled: true, visible: true},
            {path: 'tools', name: 'Application Tools', icon: 'construction', disabled: true, visible: true},
            {path: 'services', name: 'Services', icon: 'card_membership', disabled: true, visible: true},
            {path: 'support', name: 'Support', icon: 'support_agent', disabled: false, target: "_blank" , visible: true},
        ],
    },
    beforeEnter: auth.broker_zink,
    children: [
        {
            path: "dashboard",
            name: "Reporting Dashboard",
            component: ReportingDashboard
        },
        {
            path: "reporting-:tab?",
            name: "Reporting",
            component: ReportingDashboardV2,
            //props: true // Pass :tab as a prop to ReportingDashboardV2
            meta: { types: reportingTabTypes },
        },
        
        {
            path: "basket",
            name: "Workbasket",
            component: Dashboard,
            meta: { types: basketTypes },
        },
        {
            path: "capture",
            name: "Capture",
            component: Capture,
            meta: { types: captureTypes },
        },
        {
            path: "summary",
            name: "Summary",
            component: Summary,
            meta: { types: summaryTypes },
        },
        {
            path: "assessment",
            name: "Assess & Submit",
            component: Assessment,
            meta: { types: assessmentTypes },
        },
        {
            path: "documents",
            name: "Documents",
            component: Documents,
            meta: { types: documentsTypes },
        },
        {
            path: "communications",
            name: "Communication",
            component: Communications,
            meta: { types: communicationsTypes },
        },
        {
            path: "settlement_form",
            name: "Settlement Form",
            component: BrokerSettlementForm,
            meta: { types: settlementFormTypes },
        },
        {
            path: "deal_income",
            name: "Save Deal Income",
            component: SaveDealIncome,
            meta: { types: dealIncomeTypes },
        },
        {
            path: "compliance",
            name: "Compliance",
            component: Compliance,
            meta: { types: complianceTypes },
        },
        {
            path: "Auction",
            name: "Auction",
            component: Auction,
            meta: { types: auctionTypes },
        },
        {
            path: "tools/:tab?",
            name: "Tools",
            component: Tools,
            props: route => ({ tab: route.params.tab }),
            meta: { types: toolsTypes },
        },
        {
            path: "services",
            name: "Services",
            component: Services,
            meta: { types: servicesTypes },
        },
        {
            path: 'viewsettlement',
            name: "Settlement",
            component: ViewBrokerSettlement,
            meta: { types: settlementTypes },
        },
        {
            path: 'support',
            beforeEnter() {window.open( 'http://ausloans.atlassian.net/servicedesk/customer/portals', '_blank').focus() }
        },
    ]
};

import AdministrateUsers from "@/pages/AdministrateUsers.vue";
import AdministrateUserPods from "@/pages/AdministrateUserPods.vue";
import AdministrateBrokers from "@/pages/AdministrateBrokers.vue";
import AdministrateRoles from "@/pages/AdministrateRoles.vue";
import BrokerDetailViewEdit from "@/pages/BrokerDetailViewEdit.vue";
import IntroducerDetailViewEdit from "@/pages/IntroducerDetailViewEdit.vue";
import AdministrateAccounting from "@/pages/AdministrateAccounting.vue";
import AdministrateIntroducers from "@/pages/AdministrateIntroducers.vue";
import ApplicationLocks from "@/pages/ApplicationLocks.vue";
import AdministrateBATools from "@/pages/AdministrateBATools.vue";
import GlassPricesViewEdit from "@/pages/GlassPricesViewEdit.vue";
import AdministrateVedaRules from "@/pages/AdministrateVedaRules.vue";
import AdministrateMetadataReporting from "@/pages/AdministrateMetadataReporting.vue";
import AdministrateReporting from "@/pages/AdministrateReporting.vue";
import AdministrateBillings from "@/pages/AdministrateBillings.vue";
import AdministrateStorageLog from "@/pages/AdministrateStorageLog.vue";
import AdministrateServices from "@/pages/AdministrateServices.vue";
import AdministrateAuctionServices from "@/pages/AdministrateAuctionServices.vue";
import AdministrateSlaRules from "@/pages/AdministrateSLARules.vue";
import AdministrateCapacityRules from "@/pages/AdministrateCapacityRules.vue";
import AdministrateVBI from "@/pages/AdministrateVBISettings.vue";
import AdministrateAuctionLeads from "@/pages/AdministrateAuctionLeads.vue";
import DocuSignRole from "@/pages/DocuSignRole.vue";
import Journeys from "@/pages/Journal/Journeys.vue";
import JourneyManagement from "@/pages/Journal/JourneyManagement.vue";
import StepsViewEdit from "@/pages/StepsViewEdit.vue";
import StepsList from "@/pages/StepsList.vue";
let AdministrateTemplates = Templates;

let administrationPages = {
    path: "/administration",
    component: AuthenticatedLayout,
    props: {
        menu: [
            { path: '/administration/glass_prices', name: 'Glass Prices', icon: 'local_offer' },
            { path: '/administration/lenders', name: 'Lenders', icon: 'account_balance' },
            { path: '/administration/user_management', name: 'User Management', icon: 'widgets', visible: true },
            { path: '/administration/services', name: 'Services', icon: 'card_membership' },
            { path: '/administration/account', name: 'Accounts', icon: 'calculate', visible: true },
            { path: '/administration/rule', name: 'Rules', icon: 'settings_applications', visible: true },
            { path: '/administration/auction', name: 'Auction', icon: 'build_circle', visible: true },
            { path: '/administration/report', name: 'Reports', icon: 'stacked_line_chart', visible: true },
            { path: '/administration/system_general', name: 'System General Tools', icon: 'handyman', visible: true },
            { path: '/administration/journey', name: 'Journey', icon: 'widgets', visible: true },
        ],
    },
    name: "Administration",
    beforeEnter: auth.admin_zink,
    children: [
      // {
      //   path: "",
      //   name: "Administration",
      //   component: { template:'<p>Select a page on the left.</p>' }
      // },

        {
            path: "/administration/lender/:lender_id/view",
            name: "Lender Details",
            component: LenderDetailViewEdit
        },
        {
            path: "/administration/glass_prices",
            name: "Glass Prices",
            component: GlassPricesViewEdit
        },
        {
            path: "/administration/services",
            name: "Services",
            component: AdministrateServices
        },
        {
            path: "/administration/lenders",
            name: "Lenders",
            component: AdministrateLenders
        },
    ]
};

let rulePages = {
    path: "/administration/rule",
    component: AuthenticatedLayout,
    props: {
        menu: [
            { path: '/administration', name: 'Back to Administration', icon: 'engineering', visible: true },
            { path: '/administration/rule/SLArules', name: 'SLA Rules', icon: 'pivot_table_chart' },
            { path: '/administration/rule/veda_rules', name: 'Credit Report Rules', icon: 'traffic' },
            { path: '/administration/rule/capacity_rules', name: 'Capacity Rules', icon: 'rule' },
            { path: '/administration/rule/auctions', name: 'Auction Rules', icon: 'av_timer' },
        ],
    },
    name: "Rule",
    beforeEnter: auth.admin_zink,
    children: [
        {
            path: "/administration/rule/SLArules",
            name: "SLA Rules",
            component: AdministrateSlaRules,
        },
        {
            path: "/administration/rule/veda_rules",
            name: "Credit Report Rules",
            component: AdministrateVedaRules
        },
        {
            path: "/administration/rule/capacity_rules",
            name: "Capacity Rules",
            component: AdministrateCapacityRules,
        },
        {
            path: "/administration/rule/auctions",
            name: "Auctions",
            component: AdministrateAuctionServices,
        },
    ]
};
let servicePages = {
    path: "/administration/auction",
    component: AuthenticatedLayout,
    props: {
        menu: [
            { path: '/administration', name: 'Back to Administration', icon: 'engineering', visible: true },

            { path: '/administration/auction/auction_leads', name: 'Auction Leads', icon: 'fact_check' },
        ],
    },
    name: "Auction",
    beforeEnter: auth.admin_zink,
    children: [
        {
            path: "/administration/auction/auction_leads",
            name: "Auction Leads",
            component: AdministrateAuctionLeads
        },
    ]
};
let userManagementPages = {
    path: "/administration/user_management",
    component: AuthenticatedLayout,
    props: {
        menu: [
            { path: '/administration', name: 'Back to Administration', icon: 'engineering', visible: true },
            { path: '/administration/user_management/users', name: 'Users', icon: 'account_circle' },
            { path: '/administration/user_management/brokers', name: 'Brokers', icon: 'real_estate_agent' },
            { path: '/administration/user_management/introducers', name: 'Referrer / Supplier', icon: 'connect_without_contact' },
            { path: '/administration/user_management/pods', name: 'Pods', icon: 'supervised_user_circle' },
            { path: '/administration/user_management/roles', name: 'Roles', icon: 'rule' },
        ],
    },
    name: "User Management",
    beforeEnter: auth.admin_zink,
    children: [
        {
            path: "/administration/user_management/users",
            name: "Users",
            component: AdministrateUsers,
            meta: { types: ['roles', 'user_pods', 'country_states'] },
        },
        {
            path: "/administration/user_management/brokers",
            name: "Brokers",
            component: AdministrateBrokers
        },
        {
            path: "/administration/user_management/introducers",
            name: "Referrer / Supplier",
            component: AdministrateIntroducers
        },
        {
            path: "/administration/user_management/pods",
            name: "Pods",
            component: AdministrateUserPods
        },
        {
            path: "/administration/user_management/roles",
            name: "Roles",
            component: AdministrateRoles
        },
        {
            path: "/administration/user_management/broker/:broker_id/view",
            name: "Broker Details",
            component: BrokerDetailViewEdit,
            meta: { types: ['broker_employment_type', 'lenders'] },
        },
        {
            path: "/administration/user_management/broker/new",
            name: "Add New Broker",
            component: BrokerDetailViewEdit,
            meta: { types: ['broker_employment_type', 'lenders'] },
        },
        {
            path: "/administration/user_management/introducer/:introducer_id/view",
            name: "Referrer Details",
            component: IntroducerDetailViewEdit,
            meta: {
                types: [
                    'address_street_type',
                    'countries',
                    'country_states',
                    'hubspot_branding_type',
                    'hubspot_loan_purpose',
                    'loan_asset_type',
                ]
            },
        },
        {
            path: "/administration/user_management/introducer/new",
            name: "Add New Referrer",
            component: IntroducerDetailViewEdit,
            meta: {
                types: [
                    'address_street_type',
                    'countries',
                    'country_states',
                    'hubspot_branding_type',
                    'hubspot_loan_purpose',
                    'loan_asset_type',
                ]
            },
        },
    ]
};


let journey = {
    path: "/administration/journey",
    component: AuthenticatedLayout,
    props: {
        menu: [
            { path: '/administration', name: 'Back to Administration', icon: 'engineering', visible: true },
            { path: '/administration/journeys', name: 'Journey', icon: 'list_alt', visible: true },
            { path: '/administration/steps', name: 'Steps', icon:'stairs', visible: true },
        ],
    },
    name: "journey",
    beforeEnter: auth.admin_zink,
    children: [
        {
            path: "/administration/journeys",
            name: 'Journey',
            component: Journeys
          },
          {
            path: "/administration/journey/:journey_id/edit",
            name: 'JourneyManagement',
            component: JourneyManagement
          },
          {
            path: "/administration/steps",
            name: "StepsList",
            component: StepsList
          },
          {
            path: "/administration/step/new",
            name: "Step Create/Edit",
            component: StepsViewEdit
          },
          {
            path: "/administration/step/:step_id/edit",
            name: "Step Create/Edit",
            component: StepsViewEdit,
            beforeEnter: auth.isSuperAdmin,
        },
    ]
};

let accountPages = {
    path: "/administration/account",
    component: AuthenticatedLayout,
    props: {
        menu: [
            { path: '/administration', name: 'Back to Administration', icon: 'engineering', visible: true },
            { path: '/administration/account/accounting', name: 'Accounting', icon: 'calculate' },
            { path: '/administration/account/billings', name: 'Billings', icon: 'receipt'},
            { path: '/administration/account/vbi', name: 'VBI', icon: 'dashboard'},
            { path: '/administration/account/VBISettings', name: 'VBI Settings', icon: 'rule' },
        ],
    },
    name: "Account",
    beforeEnter: auth.admin_zink,
    children: [
        {
            path: "/administration/account/accounting",
            name: "Accounting",
            component: AdministrateAccounting
        },
        {
            path: "/administration/account/billings",
            name: "Billings",
            component: AdministrateBillings
        },
        {
            path: "/administration/account/vbi",
            name: "VBI",
            component: AdministrateReporting
        },
        {
            path: "/administration/account/VBISettings",
            name: "VBI Setting",
            component: AdministrateVBI,
        },
    ]
};
let reportPages = {
    path: "/administration/report",
    component: AuthenticatedLayout,
    props: {
        menu: [
            { path: '/administration', name: 'Back to Administration', icon: 'engineering', visible: true },
            { path: '/administration/report/metabase_reporting', name: 'Metabase Reporting', icon: 'dashboard'},
            { path: '/administration/report/storage_log', name: 'Storage Log', icon: 'library_books' },

        ],
    },
    name: "Report",
    beforeEnter: auth.admin_zink,
    children: [
        {
            path: "/administration/report/metabase_reporting",
            name: "Metadase Reporting",
            component: AdministrateMetadataReporting
        },
        {
            path: "/administration/report/storage_log",
            name: "Storage Log",
            component: AdministrateStorageLog
        },

    ]
};
let systemGeneralPages = {
    path: "/administration/system_general",
    component: AuthenticatedLayout,
    props: {
        menu: [
            { path: '/administration', name: 'Back to Administration', icon: 'engineering', visible: true },

            { path: '/administration/system_general/app-locks', name: 'Application Locks', icon: 'lock' },
            { path: '/administration/system_general/brokeradvisor', name: 'BA Tools', icon: 'handyman' },
            { path: '/administration/system_general/templates', name: 'Templates', icon: 'description' },
            { path: '/administration/system_general/docu_sign_role_setup', name: 'Docu Sign Role Setup', icon: 'widgets', visible: true }, 
        ],
    },
    name: "SystemGeneral",
    beforeEnter: auth.admin_zink,
    children: [
        {
            path: "/administration/system_general/app-locks",
            name: "Application Locks",
            component: ApplicationLocks
        },
        {
            path: "/administration/system_general/brokeradvisor",
            name: "BA Tools",
            component: AdministrateBATools
        },
        {
            path: "/administration/system_general/templates",
            name: "Templates",
            component: AdministrateTemplates
        },
        {
            path: "/administration/system_general/docu_sign_role_setup",
            name: "Docu Sign Role Setup",
            component: DocuSignRole
        },
        {
            path: "/administration/system_general/document_type/new",
            name: "Document Type Details",
            component: DocumentTypeViewEdit
        },
        {
            path: "/administration/system_general/document_type/:document_type_id/view",
            name: "Document Type Details",
            component: DocumentTypeViewEdit
        },
    ]
};

import Clients from "@/pages/Clients.vue";
import ViewBrokerSettlement from "../pages/Settlement/ViewBrokerSettlement";
import ReportingDashboard from "../pages/ReportingDashboard";
import ReportingDashboardV2 from "../pages/ReportingDashboardV2";
import AdministrateLenders from "../pages/AdministrateLenders";
import LenderDetailViewEdit from "../pages/LenderDetailViewEdit";
import DocumentTypeViewEdit from "../pages/DocumentTypeViewEdit";

let clientMenu = {
    path: "/",
    component: UnAuthenticatedLayout,
    name: "Client",
    props: {
        menu: [
            {path: '', name: 'Clients', icon: 'attach_file'},
        ],
    },
    children: [
        {
            path: "/client/docs/:shortcode",
            name: "Clients",
            component: Clients
        },
    ]
}

const routes = [
    {
        path: "/",
        redirect: "/application/new/basket",
        name: "Home"
    },
    {
        path: "/forgotpassword",
        name: "ForgotPassword",
        component: ForgotPassword

    },
    {
        path: "/password/reset/:token",
        name: "ResetPassword",
        component: ResetPassword,

    },
    // componentsMenu,
    formsMenu,
    // tablesMenu,
    // mapsMenu,
    // pagesMenu,
    authPages,
    applicationPages,
    clientMenu,
    administrationPages,
    {
        path: "/",
        component: AuthenticatedLayout,
        beforeEnter: (to, from, next) => {
            // @.
            if(localStorage.getItem("authenticated") === "false"){
                next("/login")
            }
            next()
        },
        // children: [
        //     {
        //         path: "calendar",
        //         name: "Calendar",
        //         components: {default: Calendar}
        //     },
        //     {
        //         path: "charts",
        //         name: "Charts",
        //         components: {default: Charts}
        //     },
        //     {
        //         path: "widgets",
        //         name: "Widgets",
        //         components: {default: Widgets}
        //     }
        // ]
    },
    rulePages,
    servicePages,
    userManagementPages,
    accountPages,
    reportPages,
    systemGeneralPages,
    journey,
];

export default {
    applicationPages,
    administrationPages,
    routes,
};
